import React from "react";
import Image from "components/Images/Image";
import { useNewsGenerate } from "./NewsGenerateContext";
import { IFile } from "types/files.d";
import AuthorSelect from "components/AuthorSelect";

const ConfigureStep: React.FC = () => {
  const {
    file,
    setFile,
    shouldGenerateImage,
    setShouldGenerateImage,
    prompt,
    setPrompt,
    author,
    setAuthor,
  } = useNewsGenerate();

  const handleImageAccept = (image: IFile) => {
    setFile(null); // Clear any existing file
    setShouldGenerateImage(false); // Disable generate image option
    setFile(image as any); // Set the new image
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 w-full">
      <div className="md:col-span-4">
        <h2 className="text-xl font-semibold mb-4">Image (Optional)</h2>
        <div className="h-[300px] w-full">
          <Image
            src={file?.url}
            onAccept={handleImageAccept}
            folderPath="News"
            context={prompt} // Pass prompt as context for AI image generation
          />
        </div>
        <div className="mt-4 flex items-center">
          <input
            type="checkbox"
            id="generateImage"
            checked={shouldGenerateImage}
            onChange={(e) => {
              setShouldGenerateImage(e.target.checked);
              // Clear the uploaded file if generate image is checked
              if (e.target.checked) {
                setFile(null);
              }
            }}
            className="mr-2"
          />
          <label htmlFor="generateImage">Generate image from prompt</label>
        </div>
        {file && shouldGenerateImage && (
          <div className="mt-2 p-4 bg-yellow-50 text-yellow-700 border border-yellow-200 rounded">
            You cannot upload an image and generate one at the same time
          </div>
        )}
      </div>
      <div className="md:col-span-8">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Basic Information</h2>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            rows={4}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>
        <div>
          <h2 className="text-xl font-semibold mb-4">Author</h2>
          <AuthorSelect
            value={author}
            onChange={(author) => setAuthor(author)}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfigureStep; 